import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { PaymentMethodName } from '../../../../enums/payment/payment-method-name';
import { BaseEditPaymentBankAccountComponent } from '../../../base/base-edit-payment-bank-account.component';

@Component({
  selector: 'admin-payment-type-payout',
  imports: [
    FormsModule,
    InputText,
    NgClass,
    InputMask
  ],
  templateUrl: './admin-payment-type-payout.component.html',
})
export class AdminPaymentTypePayoutComponent extends BaseEditPaymentBankAccountComponent {

  protected readonly PaymentMethodName = PaymentMethodName;
}
